<template>
  <div class="h-100">
    <a-menu mode="horizontal" v-model="current">
      <a-menu-item v-for="m in menuList" :key="m.key">{{ m.name }}</a-menu-item>
      <a-menu-item key="errorParameters" v-if="Object.keys(errorParameters).length > 0">{{ $t('device.errorParameters') }}</a-menu-item>
    </a-menu>
    <a-button class="switch" v-if="isSwitchShow && isSwitchButtonShow" @click="isSwicthModalShow = true">
      <img :src="swi" />
    </a-button>
    <div class="read" v-if="current[0] === 'readOnlyParameters'" style="height: calc(100% - 55px)">
      <div class="time" style="color: #777; margin: 10px 10px 0">{{ $t('device.dataUpdateTime') }}{{ time }}</div>
      <a-empty
        v-if="Object.keys(readOnlyParameters).length === 0"
        style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center;"
      />
      <ul class="parameters">
        <li v-for="(v, k) in readOnlyParameters" :key="k">
          <span>
            {{ v.name }}{{ v.unit ? `(${v.unit})` : '' }}：
            <span
              style="color: #0676de; font-weight: 500;"
              v-if="v.data.length"
            >
              {{ v.valueMap ? (v.valueMap[v.data.at(-1)[v.code]] || v.data.at(-1)[v.code]) : v.data.at(-1)[v.code] }}
              <template v-if="v.data.length > 1">
                <img
                  style="width: 35px; height: 35px;"
                  :style="{ rotate: (v.data.at(-1).rotate || 0) + 'deg', filter: v.data.at(-1).filter }"
                  :src="v.data.at(-1).src"
                />
              </template>
            </span>
            <span style="color: #999; font-weight: 500" v-else>{{ $t('common.none') }}</span>
          </span>
          <span class="function">
            <a-button
              style="margin-right: 10px; border-radius: 8px"
              v-if="(v.bitRules && v.bitRules.length) || (v.valueRules && v.valueRules.length)"
              :disabled="v.data.length === 0"
              @click="analyse(v)"
            >{{ $t('device.analyze') }}</a-button>
            <a style="width: 35px; height: 35px" @click="renderChart(v)">
              <img :src="bar" />
            </a>
          </span>
        </li>
      </ul>
    </div>
    <div class="read" v-if="current[0] === 'writableParameters'" style="height: calc(100% - 55px)">
      <div class="time" style="color: #777; margin: 10px 10px 0">{{ $t('device.dataUpdateTime') }}{{ time }}</div>
      <a-empty
        v-if="Object.keys(writableParameters).length === 0"
        style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center;"
      />
      <ul class="parameters">
        <li v-for="(v, k) in writableParameters" :key="k">
          <span>
            {{ v.name }}{{ v.unit ? `(${v.unit})` : '' }}：
            <span
              style="color: #0676de; font-weight: 500"
              v-if="v.data.length"
            >
              {{ v.valueMap ? v.valueMap[v.data.at(-1)[v.code]] : v.data.at(-1)[v.code] }}
              <template v-if="v.data.length > 1">
                <img
                  style="width: 35px; height: 35px;"
                  :style="{ rotate: (v.data.at(-1).rotate || 0) + 'deg', filter: v.data.at(-1).filter }"
                  :src="v.data.at(-1).src"
                />
              </template>
            </span>
            <span style="color: #999; font-weight: 500" v-else>{{ $t('common.none') }}</span>
          </span>
          <span class="function">
            <a-button circle style="margin-right: 10px; border-radius: 8px" @click="showWriteModal(v)">{{ $t('device.write') }}</a-button>
            <a style="width: 35px; height: 35px" @click="renderChart(v)">
              <img :src="bar" />
            </a>
          </span>
        </li>
      </ul>
    </div>
    <div class="read" v-if="current[0] === 'errorParameters'" style="height: calc(100% - 55px)">
      <a-menu mode="horizontal" v-model="error">
        <a-menu-item v-for="i in errorEndIndex" :key="'error' + i">{{ $t('device.failure') }}{{ i }}</a-menu-item>
      </a-menu>
      <template v-if="Object.keys(errorParameters).length > 0">
        <div class="time" style="color: #777; margin: 10px 10px 0">{{ $t('device.dataUpdateTime') }}{{ time }}</div>
        <a-empty
          v-if="Object.keys(errorParameters[error[0]]).length === 0"
          style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center;"
        />
        <ul class="parameters">
          <li v-for="(v, k) in errorParameters[error[0]]" :key="k">
            <span>
              {{ v.name }}{{ v.unit ? `(${v.unit})` : '' }}：
              <span
                style="color: #0676de; font-weight: 500"
                v-if="v.data.length"
              >
                {{ v.valueMap ? v.valueMap[v.data.at(-1)[v.code]] ? v.valueMap[v.data.at(-1)[v.code]].description : v.data.at(-1)[v.code] : v.data.at(-1)[v.code] }}
                <template v-if="v.data.length > 1">
                  <img
                    style="width: 35px; height: 35px"
                    :style="{ rotate: (v.data.at(-1).rotate || 0) + 'deg', filter: v.data.at(-1).filter }"
                    :src="v.data.at(-1).src"
                  />
                </template>
              </span>
              <span style="color: #999; font-weight: 500" v-else>{{ $t('common.none') }}</span>
            </span>
            <span class="function">
              <a
                v-if="v.code.startsWith('Failure_type')"
                style="margin-right: 10px; border-radius: 8px; width: 35px; height: 35px"
              >
                <img :src="sea" @click="showErrorModal(v)" />
              </a>
              <a style="width: 35px; height: 35px" @click="renderChart(v)">
                <img :src="bar" />
              </a>
            </span>
          </li>
        </ul>
      </template>
    </div>
    <div class="ant-modal-root" v-show="isChartShow">
      <div class="ant-modal-mask" style></div>
      <div
        @click="handleCloseChart"
        tabindex="-1"
        role="dialog"
        aria-labelledby="rcDialogTitle0"
        class="ant-modal-wrap"
        style
      >
        <div
          @click.stop
          role="document"
          class="ant-modal"
          style="width: 700px; transform-origin: 446px 398px;"
        >
          <div tabindex="0" aria-hidden="true" style="width: 0px; height: 0px; overflow: hidden;"></div>
          <div class="ant-modal-content">
            <div style="height: 20px"></div>
            <div class="ant-modal-body" style="padding: 0">
              <div style="width: 100%; height: 300px;" ref="chart"></div>
            </div>
          </div>
          <div tabindex="0" aria-hidden="true" style="width: 0px; height: 0px; overflow: hidden;"></div>
        </div>
      </div>
    </div>
    <div class="ant-modal-root" v-show="isBitShow">
      <div class="ant-modal-mask"></div>
      <div
        tabindex="-1"
        role="dialog"
        aria-labelledby="rcDialogTitle0"
        class="ant-modal-wrap"
        @click="isBitShow = false"
      >
        <div
          @click.stop
          role="document"
          class="ant-modal"
          style="width: 300px; transform-origin: 439px 114px;"
        >
          <div tabindex="0" aria-hidden="true" style="width: 0px; height: 0px; overflow: hidden;"></div>
          <div class="ant-modal-content">
            <div class="ant-modal-header" sty>
              <div
                id="rcDialogTitle0"
                class="ant-modal-title"
                style="text-align: center"
              >{{ bitTitle }}</div>
            </div>
            <div class="ant-modal-body">
              <p v-for="b in bits" :key="b.pos" style="font-size: 16px">
                <span style="color: #0676de; font-weight: 500">{{ b.name }}</span>
                ：{{ b.value }}
              </p>
            </div>
          </div>
          <div tabindex="0" aria-hidden="true" style="width: 0px; height: 0px; overflow: hidden;"></div>
        </div>
      </div>
    </div>
    <div class="ant-modal-root" v-show="isWriteShow">
      <div class="ant-modal-mask"></div>
      <div @click="isWriteShow = false" tabindex="-1" role="dialog" aria-labelledby="rcDialogTitle0" class="ant-modal-wrap">
        <div @click.stop role="document" class="ant-modal" style="width: 350px; transform-origin: 470px 422px;">
          <div tabindex="0" aria-hidden="true" style="width: 0px; height: 0px; overflow: hidden;"></div>
          <div class="ant-modal-content">
            <div class="ant-modal-header" style="border: none; text-align: center">
              <div id="rcDialogTitle0" class="ant-modal-title">{{ $t('device.setParameters') }}</div>
            </div>
            <div class="ant-modal-body">
              <p>
                <span style="font-weight: 500">{{ parameterName }}：</span>
                {{ parameterValue }}
              </p>
              <p>
                <span style="font-weight: 500">{{ $t('device.setRange') }}</span>
                {{ (range[0] || range[0] == 0) ? range[0] : '~' }} ~ {{ range[1] || '~' }}
              </p>
              <p>
                <span style="font-weight: 500; margin-right: 10px">{{ $t('device.setValue') }}</span>
                <a-input v-model="parameterData" style="width: auto; margin-right: 8px" />
                {{ unit }}
              </p>
            </div>
            <div class="ant-modal-footer">
              <div>
                <button @click="closeWriteModal" type="button" class="ant-btn">
                  <span>{{ $t('common.cancelText') }}</span>
                </button>
                <a-button type="primary" :loading="isWriting" @click="write">{{ $t('common.okText') }}</a-button>
              </div>
            </div>
          </div>
          <div tabindex="0" aria-hidden="true" style="width: 0px; height: 0px; overflow: hidden;"></div>
        </div>
      </div>
    </div>
    <div class="ant-modal-root" v-show="isErrorShow">
      <div class="ant-modal-mask"></div>
      <div @click="closeErroeModal" tabindex="-1" role="dialog" aria-labelledby="rcDialogTitle0" class="ant-modal-wrap">
        <div @click.stop role="document" class="ant-modal" style="width: 350px; transform-origin: 470px 422px;">
          <div tabindex="0" aria-hidden="true" style="width: 0px; height: 0px; overflow: hidden;"></div>
          <div class="ant-modal-content" style="position: relative">
            <div class="ant-modal-header" style="border: none; text-align: center">
              <div id="rcDialogTitle0" class="ant-modal-title" style="display: flex; justify-content: center; align-items: center">
                <div class="error_code">
                  {{ errorCode }}
                </div>
              </div>
            </div>
            <div class="ant-modal-body error">
              <ul>
                <li>
                  <p class="title">{{ $t('device.errorName') }}</p>
                  <p class="content">{{ errorName }}</p>
                </li>
                <li>
                  <p class="title">{{ $t('device.transducerCode') }}</p>
                  <p class="content">{{ transducerCode }}</p>
                </li>
                <li>
                  <p class="title">{{ $t('device.reasons') }}</p>
                  <ul class="reasons">
                    <li v-for="(r, i) in reasons" :key="i">
                      {{ r }}
                    </li>
                  </ul>
                </li>
              </ul>
              <div style="display: flex; justify-content: center; align-items: center; margin-top: 20px">
                <a-button type="primary" style="border-radius: 20px" :loading="isRefreshErrorCode" @click="getErrorCodeList(Transducer)">{{ $t('device.refreshErrorList') }}</a-button>
              </div>
            </div>
          </div>
          <div tabindex="0" aria-hidden="true" style="width: 0px; height: 0px; overflow: hidden;"></div>
        </div>
      </div>
    </div>
    <div class="ant-modal-root" v-show="isSwicthModalShow">
      <div class="ant-modal-mask" style></div>
      <div
        @click="isSwicthModalShow = false"
        tabindex="-1"
        role="dialog"
        aria-labelledby="rcDialogTitle0"
        class="ant-modal-wrap"
        style
      >
        <div
          @click.stop
          role="document"
          class="ant-modal"
          style="width: 290px; transform-origin: 446px 398px;"
        >
          <div tabindex="0" aria-hidden="true" style="width: 0px; height: 0px; overflow: hidden;"></div>
          <div class="ant-modal-content" style="overflow: hidden">
            <div class="ant-modal-header" style="border: none; text-align: center">
              <div id="rcDialogTitle0" class="ant-modal-title" style="display: flex; justify-content: center; align-items: center">
                <div style="color: #2690ec; font-size: 18px; text-align: center">
                  {{ $t('device.deviceSwitch') }}
                </div>
              </div>
            </div>
            <div class="ant-modal-body btns" style="padding: 0 10px">
              <div class="btn open" @click="hanldeDeviceSwitch(0)">
                <span class="i">I</span>{{ $t('device.open') }}
              </div>
              <div class="btn close" @click="hanldeDeviceSwitch(1)">
                <span class="o">O</span>{{ $t('device.close') }}
              </div>
            </div>
            <div class="ant-modal-foot" style="padding: 20px 10px">
              <a-button type="primary" style="float: right; border-radius: 15px" @click="isSwicthModalShow = false">{{ $t('common.cancelText') }}</a-button>
              <div style="height: 30px"></div>
            </div>
          </div>
          <div tabindex="0" aria-hidden="true" style="width: 0px; height: 0px; overflow: hidden;"></div>
        </div>
      </div>
    </div>
    <a-modal :width="200" v-model="interruptShow" :title="$t('device.kl')" :ok-text="$t('common.okText')" :cancel-text="$t('common.cancelText')" @cancel="handleInterruptClose" @ok="handleInterruptConfirm">
      <p>
        {{ i }} {{ $t('device.continueToListen') }}
      </p>
    </a-modal>
  </div>
</template>

<script>
import { getProtocol } from "@/api/protocol";
import { switchDevice, writeValue } from "@/api/device";
import { getErrorCodeList } from '@/api/error_code'
import bar from "@/assets/bar.png";
import sea from "@/assets/sea.png";
import blue from "@/assets/blue.gif";
import red from "@/assets/red.gif";
import moment from "moment";
import swi from '@/assets/switch.png'

export default {
  props: {
    device: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      menuList: [
        {
          key: "readOnlyParameters",
          name: this.$t('device.readOnlyParameters')
        },
        {
          key: "writableParameters",
          name: this.$t('device.writableParameters')
        }
      ],
      swi,
      i: 5,
      interruptShow: false,
      errorCode: 0,
      errorName: this.$t('common.none'),
      reasons: [],
      current: ["readOnlyParameters"],
      errorEndIndex: 0,
      readOnlyParameters: {},
      writableParameters: {},
      errorParameters: {},
      isSwitchShow: false,
      bar,
      sea,
      isChartShow: false,
      red,
      blue,
      isBitShow: false,
      bits: [],
      bitTitle: "",
      isWriteShow: false,
      parameterName: "",
      parameterValue: "",
      range: [],
      unit: "",
      isWriting: false,
      parameterData: '',
      inverterCode: '',
      errorCodeMap: {},
      Transducer: '',
      transducerCode: this.$t('common.none'),
      isErrorShow: false,
      isRefreshErrorCode: false,
      time: '',
      isSwicthModalShow: false,
      error: ['error1'],
      isSwitchButtonShow: false
    };
  },
  created() {
    // const ea = this.getAuthorities('/equipment/list')
    // const aa = this.getAuthorities('/list')
    // const e = ea.find(a => a.code === '')
    if (this.device.type === 'KYJ') {
      this.isSwitchButtonShow = this.getAuthorities('/list').find(a => a.code === 'device:manage:remote:switch')
    } else {
      this.isSwitchButtonShow = this.getAuthorities('/equipment/list').find(a => a.code === 'device:station:remote:switch')
    }
    this.translate()
    this.getPoints();
  },
  beforeDestroy() {
    this.webSocket.close()
    this.webSocket = null
    this.chart.dispose()
    this.chart = null
  },
  mounted() {
    this.initChart();
    // this.getErrorCodeList()
  },
  computed: {
    lang() {
      return this.$store.state.lang
    }
  },
  watch: {
    Transducer(val) {
      console.log(val);
      if (val && ['700', '650', '1000', '2000', '3000'].includes(val + '')) {
        this.getErrorCodeList(val)
      }
    },
    lang() {
      this.translate()
    }
  },
  methods: {
    translate() {
      this.menuList = [
        {
          key: "readOnlyParameters",
          name: this.$t('device.readOnlyParameters')
        },
        {
          key: "writableParameters",
          name: this.$t('device.writableParameters')
        }
      ]
      if (this.points?.length) {
        this.setPoints()
      }
    },
    setTransducerToType(val) {
      let type
      if (val == 700 || val == 650) {
        type = 'CP650/CP700'
      }
      if (val == 1000) {
        type = 'G1000'
      }
      if (val == 2000 || val == 3000) {
        type = 'G2000/G3000'
      }
      this.transducerCode = type
    },
    async getPoints() {
      const { data } = await getProtocol(this.device.protocolCode);
      this.points = data.points.filter(d => d.dataWrite !== 2).map(p => {
        (p.details || []).forEach(d => {
          p[d.locale.split('-')[0]] = d.name
        })
        if (!p.zh) {
          p.zh = p.name
        }
        if (!p.en) {
          p.en = p.zh
        }
        return p
      });
      this.setPoints();
    },
    async getErrorCodeList(val) {
      this.isRefreshErrorCode = true
      this.setTransducerToType(val)
      try {
        const { data } = await getErrorCodeList(this.transducerCode)
        data.forEach(d => {
          this.errorCodeMap[d.code] = d
        })
        if (this.errorPoint) {
          this.showErrorModal(this.errorPoint)
        }
      } catch(e) {
        console.log(e)
      } finally {
        this.isRefreshErrorCode = false
      }
    },
    setPoints() {
      this.points.forEach(p => {
        if (p.code.startsWith("Failure_type")) {
          this.errorEndIndex = Math.max(
            isNaN(p.code.at(-1)) ? 0 : +p.code.at(-1),
            this.errorEndIndex
          );
        }
      });
      for (let i = 0; i < this.points.length; i++) {
        const p = this.points[i];
        if (p.dataWrite === 4) {
          this.isSwitchShow = true;
          this.switchRange = p.range;
        }
        if (p.code.startsWith("Failure")) {
          const n = +p.code.at(-1);
          this.errorEndIndex = Math.max(isNaN(n) ? 0 : n, this.errorEndIndex);
          if (n > 0) {
            if (!this.errorParameters[`error${n}`]) {
              this.errorParameters[`error${n}`] = {
                [p.code]: {
                  code: p.code,
                  name: p[this.lang],
                  unit: p.unit,
                  data: [],
                  bitRules: p.bitRules,
                  valueRules: p.valueRules
                }
              };
            } else {
              this.errorParameters[`error${n}`][p.code] = {
                code: p.code,
                name: p[this.lang],
                unit: p.unit,
                data: [],
                bitRules: p.bitRules,
                valueRules: p.valueRules
              };
            }
          }
        }
        if (p.dataWrite === 0) {
          this.readOnlyParameters[p.code] = {
            code: p.code,
            name: p[this.lang],
            unit: p.unit,
            data: [],
            bitRules: p.bitRules,
            valueRules: p.valueRules
          };
        }
        if (p.dataWrite === 1 || p.dataWrite === 4) {
          this.writableParameters[p.code] = {
            code: p.code,
            name: p[this.lang],
            unit: p.unit,
            data: [],
            bitRules: p.bitRules,
            valueRules: p.valueRules,
            range: p.range
          };
        }

        if (p.valueRules?.length && this.readOnlyParameters[p.code]) {
          this.readOnlyParameters[p.code].valueMap = {
            '0': '0'
          };
          p.valueRules.forEach(v => {
            this.readOnlyParameters[p.code].valueMap[v.targetValue] = v.value;
          });
        }
      }
      this.connectServer()
      this.$forceUpdate();
    },
    initChart() {
      if (!this.chart) {
        this.chart = this.$echarts.init(this.$refs.chart, null, {
          renderer: "canvas",
          useDirtyRect: false,
          width: 700,
          height: 300
        });
      }
      this.option = {
        tooltip: {
          trigger: "axis",
          position: function(pt) {
            return [pt[0], "10%"];
          }
        },
        title: {
          text: "",
          x: "center"
        },
        xAxis: {
          data: [],
          axisLabel: {
            showMaxLabel: true
          },
          axisTick: {
            inside: true
          }
        },
        yAxis: {
          type: "value",
          boundaryGap: [0, "100%"]
        },
        series: [
          {
            name: "",
            type: "line",
            data: []
          }
        ]
      };
      this.chart.setOption(this.option);
    },
    renderChart(v) {
      this.isChartShow = true;
      this.showingChart = v.code
      this.option.title.text = v.name;
      this.option.series[0].name = v.name;
      let originData
      if (this.current[0].startsWith('error')) {
        originData = this.errorParameters[this.current[0]]?.[v.code]?.data || []
      } else {
        originData = this[this.current[0]]?.[v.code]?.data || []
      }
      this.option.xAxis.data = []
      this.option.series[0].data = []
      originData.forEach(o => {
        this.option.xAxis.data.push(moment(+new Date(o.time)).format('HH:mm:ss'))
        this.option.series[0].data.push(o[v.code])
      })
      this.chart.setOption(this.option, { replaceMerge: ["xAxis", "yAxis", "series"]});
    },
    analyse(v) {
      if (v.bitRules?.length) {
        let value = []
        let result = v.data.at(-1)[v.code]
        while (result != 0) {
          value.push(result % 2)
          result = Math.floor(result / 2)
        }
        // const value = v.data.at(-1)[v.code].toString(2);
        for (let i = value.length; i < 16; i++) {
          value.push(0)
        }
        value = value.join('')
        const lang = this.lang === "en" ? "en-US" : "zh-CN"
        this.bits = v.bitRules.map(b => {
          b.value = value[b.pos - 1] === "1" ? b[`one_${lang}`] : b[`zero_${lang}`];
          b.name = b[`name_${lang}`]
          const d = (b.details || []).find(d => d.locale === lang)
          if (d) {
            b.name = d.name
          }
          if (value[b.pos - 1] === "1") {
            const o = (b.ones || []).find(o => o.locale === lang)
            if (o) {
              b.value = o.value
            }
          } else {
            const z = (b.zeros || []).find(z => z.locale === lang)
            if (z) {
              b.value = z.value
            }
          }
          return b;
        });
        this.bitTitle = this.$t('device.bitRule');
        this.isBitShow = true;
      }
      if (v.valueRules?.length) {
        const i = {
          name: `=${v.data.at(-1)[v.code]}`,
          value: v.valueRules.find(
            val => val.targetValue == v.data.at(-1)[v.code]
          )?.value || ""
        };
        this.bits = [i];
        this.bitTitle = this.$t('device.valueRule');
        this.isBitShow = true;
      }
    },
    async hanldeDeviceSwitch(i) {
      try {
        // console.log({
        //   dtuCode: this.device.dtuCode,
        //   deviceCode: this.device.code,
        //   pointCode: 'switch',
        //   value: this.switchRange[i]
        // });
        const { message } = await switchDevice({
          dtuCode: this.device.dtuCode,
          deviceCode: this.device.code,
          pointCode: "switch",
          value: this.switchRange[i]
        });
        this.$message.success(message);
      } catch (e) {
        console.log(e);
      }
    },
    showWriteModal(v) {
      this.parameterName = v.name;
      this.parameterValue = v.data.at(-1)?.[v.code] || this.$t('common.none');
      this.range = v.range;
      this.unit = v.unit;
      this.code = v.code
      this.isWriteShow = true;
    },
    async write() {
      this.isWriting = true
      try {
        // console.log({
        //   dtuCode: this.device.dtuCode,
        //   deviceCode: this.device.code,
        //   pointCode: this.code,
        //   value: this.parameterData
        // });
        const { message } = await writeValue({
          dtuCode: this.device.dtuCode,
          deviceCode: this.device.code,
          pointCode: this.code,
          value: this.parameterData
        })
        this.$message.success(message)
      } catch(e) {
        console.log(e)
      } finally {
        this.isWriting = false
      }
    },
    clearWriteForm() {
      this.parameterName = ''
      this.parameterValue = ''
      this.range = ''
      this.unit = ''
    },
    closeWriteModal() {
      this.isWriteShow = false
      this.clearWriteForm()
    },
    handleInterruptClose() {
      this.interruptShow = false
      clearInterval(this.interruptTimer)
      this.i = 5
      this.interruptShow = null
      this.webSocket.send('stop')
      this.webSocket.close()
    },
    handleInterruptConfirm() {
      this.interruptShow = false
      clearInterval(this.interruptTimer)
      this.i = 5
      this.interruptShow = null
      this.webSocket.send('continue')
    },
    connectServer() {
      if (this.websocket) {
        this.websocket.close()
      }

      const authorization = 'Bearer ' + JSON.parse(localStorage.getItem('token'))
      this.webSocket = new WebSocket(`wss://ygk.deman.cn:9006/ws/device/${this.device.id}?token=${authorization}`)

      let time
      let temp
      let d
      let dd
      this.webSocket.onmessage = ({ data }) => {
        if (data === 'monitorTime') {
          this.webSocket.send('stop')
          this.interruptTimer = setTimeout(() => {
            this.webSocket.close()
            this.$message.info(this.$t('device.endMonitor'))
          }, 10000)
          return
        }
        const record = JSON.parse(data)
        time = record.time || new Date()
        this.time = moment(+new Date(time)).format('HH:mm:ss')
        for (let k in record) {
          if (k === 'Transducer') {
            this.Transducer = record[k]
          }
          if (k === 'save_maintain_time') {
            record[k] = record['maintain_time']
          }
          if (this.readOnlyParameters[k]) {
            
            temp = this.readOnlyParameters[k].data
            this.readOnlyParameters[k].data.push({
              time,
              [k]: record[k]
            })
            d = this.readOnlyParameters[k].data.at(-1)
            dd = this.readOnlyParameters[k].data.at(-2)
            if (temp?.length > 1) {
              if (d[k] > dd[k]) {
                d.src = this.red
                d.rotate = 180
              } else if (d[k] == dd[k]) {
                d.src = this.blue
                d.rotate = 270
              } else {
                d.src = this.blue
                d.rotate = 0
                d.filter = 'hue-rotate(268deg)'
              }
            }
          }
          if (this.writableParameters[k]) {
            temp = this.writableParameters[k].data
            this.writableParameters[k].data.push({
              time,
              [k]: record[k]
            })
            d = this.writableParameters[k].data.at(-1)
            dd = this.writableParameters[k].data.at(-2)
            if (temp?.length > 1) {
              if (d[k] > dd[k]) {
                d.src = this.red
                d.rotate = 180
              } else if (d[k] == dd[k]) {
                d.src = this.blue
                d.rotate = 270
              } else {
                d.src = this.blue
                d.rotate = 0
              }
            }
          }
          for (let j in this.errorParameters) {
            if (this.errorParameters[j][k]) {
              temp = this.errorParameters[j][k].data
              this.errorParameters[j][k].data.push({
                time,
                [k]: record[k]
              })
              if (k.startsWith('Failure_type')) {
                this.errorParameters[j][k].valueMap = this.errorCodeMap
              }
              d = this.errorParameters[j][k].data.at(-1)
              dd = this.errorParameters[j][k].data.at(-2)
              if (temp?.length > 1) {
                if (d[k] > dd[k]) {
                  d.src = this.red
                  d.rotate = 180
                } else if (d[k] == dd[k]) {
                  d.src = this.blue
                  d.rotate = 270
                } else {
                  d.src = this.blue
                  d.rotate = 0
                }
              }
            }
          }
          // if (this[this.current[0]][k]) {
          //   time = record.time || new Date()
          //   temp = this[this.current[0]][k].data
          //   this[this.current[0]][k].data.push({
          //     time,
          //     [k]: record[k]
          //   })
          //   d = this[this.current[0]][k].data.at(-1)
          //   dd = this[this.current[0]][k].data.at(-2)
          //   if (temp?.length > 1) {
          //     if (d[k] > dd[k]) {
          //       d.src = this.red
          //       d.rotate = 180
          //     } else if (d[k] == dd[k]) {
          //       d.src = this.blue
          //       d.rotate = 270
          //     } else {
          //       d.src = this.blue
          //       d.rotate = 0
          //     }
          //   } 
          // }
        }

        if (record[this.showingChart]) {
          this.option.xAxis.data.push(moment(+new Date(time)).format('HH:mm:ss'))
          this.option.series[0].data.push(record[this.showingChart])
          this.chart.setOption(this.option, { replaceMerge: ["xAxis", "yAxis", "series"]})
        }
        this[this.current[0]] = {...this[this.current[0]]}
      }
    },
    handleCloseChart() {
      this.isChartShow = false
      this.showingChart = null
    },
    closeErroeModal() {
      this.errorPoint = null
      this.isErrorShow = false
    },
    showErrorModal(v) {
      this.errorPoint = v
      this.isErrorShow = true
      if (v.data.length) {
        const i = v.data.at(-1)
        if (i[v.code] === 0) {
          this.errorCode = 0
          this.errorName = this.$t('common.none')
          this.transducerCode = this.$t('common.none')
          this.reasons = [this.$t('common.none')]
        } else {
          this.errorCode = i[v.code]
          this.errorName = v.valueMap[i[v.code]].description
          this.reasons = v.valueMap[i[v.code]].reasons
        }
      } else {
        this.errorCode = 0
        this.errorName = this.$t('common.none')
        this.transducerCode = this.$t('common.none')
        this.reasons = [this.$t('common.none')]
      }
    }
  }
};
</script>

<style lang="less" scoped>
ul {
  margin: 0;
  padding: 0;
}
.parameters {
  width: 100%;
  height: calc(100% - 24px);
  // background-color: skyblue;
  // display: grid;
  padding: 6px 30px 7px;
  font-size: 16px;
  // grid-template-columns: repeat(4, 1fr);
  overflow: auto;
  li {
    width: 25%;
    float: left;
    display: flex;
    padding-right: 30px;
    justify-content: space-between;
    align-items: center;
  }
  .function {
    font-size: 14px;
  }
  a {
    display: inline-block;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.error_code {
  padding: 0;
  margin: 0;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  border: 2px solid red;
  border-radius: 5px;
}
.error {
  .title {
    font-size: 18px;
    font-weight: 500;
    display: flex;
    align-items: center;
    &::before {
      display: inline-block;
      width: 5px;
      height: 20px;
      margin-right: 10px;
      content: '';
      background-color: #0674ef;
    }
  }
  .content {
    color: #2690ec;
    text-align: center;
    font-size: 16px;
  }
  .reasons {
    width: 90%;
    height: 100%;
    margin: 10px auto;
    background-color: #e0dfe4;
    padding: 15px;
    border-radius: 5px;
    li {
      display: flex;
      align-items: center;
    }
    li:not(:last-child) {
      margin-bottom: 10px;
    }
    li::before {
      content: '';
      width: 4px;
      height: 4px;
      border-radius: 2px;
      margin-right: 6px;
      background-color: #555;
    }
  }
}
.switch {
  width: 50px;
  height: 50px;
  float: right;
  background-color: #efefef;
  padding: 0;
  position: absolute;
  right: 10px;
  top: -3px;
  img {
    width: 40px;
    height: 40px;
  }
}
.btns {
  display: flex;
  justify-content: space-between;
  .btn {
    width: 48%;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    font-size: 18px;
    color: #fff;
    border-radius: 5px;
    cursor: pointer;
    span {
      display: inline-block;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      border: 1px solid #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 450;
      margin-right: 10px;
      font-size: 20px;
    }
  }
  .open {
    background-color: #68a987;
  }
  .close {
    background-color: #e77361;
  }
}
</style>
